import React, { FC } from "react";

import { CloseIcon } from "../Icons";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import { IPrequalificationInfoResponse } from "../../services/prequalification";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { logPrequalEvent } from "../../shared/containers/PrequalificationContainer/prequalAnalytics";
import { usePrequalContinuation } from "../../hooks/usePrequalContinuation";

interface IPrequalContinuationCardProps {
  record: IPrequalificationInfoResponse;
  pet: IPetItemResponse;
  onDismiss: () => void;
}

// Purchase-continuation banner (Figma 35835-63663): same Upsell Card shell as
// PrequalDashboardCard, violet variant, shown while a valid prequalification
// has no completed purchase yet. Routing (Plan Selection vs Billing Options)
// is owned by usePrequalContinuation.
const PrequalContinuationCard: FC<IPrequalContinuationCardProps> = ({
  record,
  pet,
  onDismiss,
}) => {
  const { continueFromRecord } = usePrequalContinuation({
    source: "prequal_continuation_card",
  });

  const handleDismiss = () => {
    logPrequalEvent(MIXPANEL_EVENTS.PREQUAL_BANNER_DISMISSED, {
      surface: "continuation_card",
      prequal_status_at_dismiss: record.status,
    });
    onDismiss();
  };

  return (
    <div className="medium:py-6 medium:px-4 bg-[#B8BFE9] p-4">
      <div className="rounded-xl bg-white p-4 flex flex-col gap-3 relative">
        <div className="flex gap-3 items-center">
          <img
            alt="prequalification_continuation_icon"
            className="w-20 h-20"
            src="/assets/icons/PrequalContinuation.svg"
          />
          <div className="flex flex-col justify-center gap-1 pr-6">
            <div className="!text-base font-semibold">
              {pet.name}&apos;s plan is waiting
            </div>
            <div className="!text-xs font-normal grow">
              Complete your purchase to unlock {pet.name}&apos;s full year of TotalCare benefits.
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div
            className="text-xs text-center w-full bg-[#E6E5F1]
            p-2 rounded-2xl font-semibold hover:bg-[#D8D7E9] cursor-pointer"
            onClick={() => continueFromRecord(record)}
          >
            Become a Member
          </div>
        </div>
        <div className="absolute top-2 right-2 hover:bg-taupe-1 hover:rounded-full">
          <CloseIcon
            onClick={handleDismiss}
            className="text-light-black cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default PrequalContinuationCard;
